import React from "react";
import { getConfiguration, getPrintableAmount } from "../../data/utils";

export default function DefaultStakes(props) {
    const conf = getConfiguration();

    if (conf.bak?.dsk !== true) {
        return null;
    }

	const mult = conf.cs.m;
	const nDec = conf.cs.nd;

    return (
        <div className="b_12_2">
            {conf.bak.vls.map((a,i) =>
                <div key={i} className="b_12_2_1" onClick={() => props.setAmountFromCalc(a)}>{getPrintableAmount(a, mult, nDec)}</div>
            )}
        </div>
    );
}
